import { useTranslation } from "react-i18next";
import React, { useState, useEffect, Fragment, useCallback } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import apiRequest from "../../functions/api";
import { Typography, TableRow, Button, Checkbox, FormControlLabel, Box, Select, ListItem, ListItemButton } from "@mui/material";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import { useMessage } from "../../context/message-context";
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import { FullPageSpinner } from "../lib";
import openFile from "../shared/functions/download";
import Formular from "../Formular/Formular";
import FormularEingabe from "../Formulare/FormularEingabe";
function MandatoryDocForm(props) {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const [documents, setDocuments] = useState(null);
  const [fileName, setFileName] = useState("");
  const { accessToken, client, formular, liste, felder, pflichtdok, disabled } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [formularFelder, setFormularFelder] = useState(felder);
  const [, updateState] = useState();
  const [felderError, setFelderError] = useState([]);

  const forceUpdate = useCallback(() => updateState({}), []);
  const [antworten, setAntworten] = useState({});
  const { hideMessage, showErrorMessage } = useMessage();
  const vorschau = location?.state?.vorschau ? location?.state.vorschau : "";

  const setzeAntworten = (key, value) => {
    let values = Object.assign(antworten);
    values[key] = value;
    console.log(values);
    setAntworten(values);
    forceUpdate();
  };
  const setzeAntwortenDropbox = (key, value) => {
    let values = Object.assign(antworten);
    if (value === true) {
      values[key] = "Ja";
    } else {
      values[key] = "Nein";
    }
    console.log(values);
    setAntworten(values);
    forceUpdate();
  };
  const closeModal = () => {
    setShowModal(false);
  };
  const open = () => {
    setShowModal(true);
    downloadFile();
  };
  const schreibeDaten = () => {
    if (vorschau !== "") {
      navigate(-1);
      return;
    }
    const payload = {
      mandant: client,
      program: "WEBPDB",
      statement: "SPEICHERN",
      hdsakey: pflichtdok,
      antworten: antworten,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, schreibeCb);
  };
  const schreibeCb = (response) => {
    if (response.status === 200) {
      hideMessage();
      navigate(-1);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };

  function ChangeFelder(id, value, newfelder) {
    //setFelder(newFelder)
    console.log(newfelder);
    setFormularFelder(JSON.parse(JSON.stringify(newfelder)));
  }
  const formularAbsenden = (felder) => {
    if (Plausibilitaetspruefung() === 1) {
      showErrorMessage(t("Bitte füllen Sie alle Pflichtfelder aus"));
      return;
    }
    const payload = {
      mandant: client,
      program: "WEBPDB",
      statement: "FORMULAR_ANTWORT_ABSENDEN",
      hdsakey: pflichtdok,
      formular: formular,
      antworten: formularFelder,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, schreibeCb);
  };
  function Plausibilitaetspruefung() {
    var tmpError = [];
    console.log;
    var inhalt = formularFelder[formular]["F" + formular.substr(1, 3)].inhalt;
    var tmpliste = inhalt.split(";");
    tmpliste.forEach((item, index) => {
      if (item.substr(0, 1) === "S") return;
      if (item.substr(0, 1) === "P") return;
      if (item.substr(0, 1) === "G") {
        var istPflicht = 0;
        var truePflicht = {};
        var tmparray = formularFelder[formular][item].inhalt.split(";");
        tmparray.forEach((item2, index2) => {
          if (item2.substr(0, 1) !== "E") return;
          if (truePflicht[item2] == undefined) truePflicht[item2] = 0;
          if (!formularFelder[formular][item2].antwort || formularFelder[formular][item2].antwort.length === 0) return;
          var keys = Object.keys(formularFelder[formular][item2].antwort);
          keys.forEach((key) => {
            if (
              (formularFelder[formular][item2].antwort[key] == "" && formularFelder[formular][item2].typ !== "09") ||
              formularFelder[formular][item2].antwort[key] === ""
            )
              return;
            istPflicht = Math.max(Number(key), istPflicht);
            if (formularFelder[formular][item2].pflicht === "1" && Number(key) - truePflicht[item2] <= 1) truePflicht[item2] = Number(key);
          });
        });
        var keys = Object.keys(truePflicht);
        keys.forEach((key) => {
          if (formularFelder[formular][key].pflicht !== "1") return;
          if (istPflicht > truePflicht[key]) {
            tmpError.push(key + istPflicht.toString());
          }
        });
      }
      if (formularFelder[formular][item].logik === "03") {
        if (!formularFelder[formular][item].antwort || formularFelder[formular][item].antwort === "") {
          if (formularFelder[formular][item].logikwert.includes("=")) {
            let bedingung = formularFelder[formular][item].logikwert.split("=");
            console.log(formularFelder[formular][bedingung[0]]?.antwort === bedingung[1]);
            bedingung[0] = bedingung[0].replaceAll("|", "").replaceAll(" ", "");
            if (formularFelder[formular][bedingung[0]]?.antwort === bedingung[1]) {
              tmpError.push(item);
            }
          } else if (formularFelder[formular][item].logikwert.includes("<>")) {
            let bedingung = formularFelder[formular][item].logikwert.split("<>");
            bedingung[0] = bedingung[0].replaceAll("|", "").replaceAll(" ", "");
            if (formularFelder[formular][bedingung[0]]?.antwort !== bedingung[1]) {
              tmpError.push(item);
            }
          } else if (formularFelder[formular][item].logikwert.includes("<")) {
          } else if (formularFelder[formular][item].logikwert.includes(">")) {
          }
        }
      }
      if (formularFelder[formular][item].pflicht !== "1") return;
      var typ = formularFelder[formular][item].typ;
      if (typ === "01") {
        if (!formularFelder[formular][item].antwort || formularFelder[formular][item].antwort === "") tmpError.push(item);
      }
      if (typ === "02") {
        if (!formularFelder[formular][item].antwort || formularFelder[formular][item].antwort === "") tmpError.push(item);
      }
      if (typ === "03") {
        if (!formularFelder[formular][item].antwort || formularFelder[formular][item].antwort === "") tmpError.push(item);
      }
      if (typ === "04") {
        if (!formularFelder[formular][item].antwort || formularFelder[formular][item].antwort === "") tmpError.push(item);
      }
      if (typ === "05") {
        if (!formularFelder[formular][item].antwort || formularFelder[formular][item].antwort === "0") tmpError.push(item);
      }
      if (typ === "06") {
        if (!formularFelder[formular][item].antwort || formularFelder[formular][item].antwort === "") tmpError.push(item);
      }
      if (typ === "07") {
        if (!formularFelder[formular][item].antwort || formularFelder[formular][item].antwort === "") tmpError.push(item);
      }
      if (typ === "08") {
        if (!formularFelder[formular][item].antwort) {
          tmpError.push(item);
        } else {
          var check = 0;
          const items = Object.values(formularFelder[formular][item].antwort);
          items.forEach((item) =>
            Object.entries(item).forEach(([key, value]) => {
              if (value === "1") check = 1;
            })
          );
          if (check === 0) tmpError.push(item);
        }
      }
    });
    setFelderError(tmpError);
    if (tmpError.length > 0) {
      return 1;
    } else {
      return 0;
    }
  }

  const ladeDocuments = () => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "WEBPDB",
      statement: "AUSWAHL",
      hdsakey: pflichtdok,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, documentCb);
  };
  // useEffect(() => {
  //   if (fileName !== '') {
  //     // open();
  //   }
  //   // eslint-disable-next-line
  // }, [documents, fileName]);
  useEffect(() => {
    console.log(formularFelder);
  }, [formularFelder]);
  return (
    <>
      {/* <FormularEingabe
            client={client}
            accessToken={accessToken}
            formular={
              formular
            }
            formularkey={formular}
            // Reload={Reload}
            // setFormular={setFormular}
            // workflow={workflow}
            // setFormularkey={setLadenFormular}
            // ans={ans}
            // ankey={ankey.current}
          /> */}
      <Formular
        key={"1"}
        bez={"test"}
        formular={formular}
        liste={felder[formular][formular]?.inhalt.split(";")}
        felder={formularFelder}
        stammfelder={formular}
        // hper={hper}
        ChangeFelder={ChangeFelder}
        // uebergaben={uebergaben}
        felderError={felderError}
        lock={disabled}
        // ChangeFiles={ChangeFiles}
        // files={files}
        // DateiLaden={DateiLaden}
        // bemerkung={bemerkung}
        ZSpeichern={console.log}
        // client={client}
        // accessToken={accessToken}
        // program={"FORMUL"}
      />
      {!disabled && <Button onClick={() => formularAbsenden(felder)}>Absenden</Button>}
    </>
  );
}
export default MandatoryDocForm;
